module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_20-07b4dbb620d35cca010530ffa464454b.jpg";